import { PageInfoDto } from '@/dto';

export let dataItem = [
  		'id',
  'guid',
  'number',
  'name',
  'active',

];

export let dataInfo = [
  		'id',
  'guid',
  'number',
  'name',
  'createdByUserId',
  'modifiedByUserId',
  'dateCreated',
  'dateModified',
  'active',

];

export class listDto {
  constructor(results) {
    this.items = results.items.map(item => new gridDto(item));
    this.pageInfo = new PageInfoDto(results.paging);
  }
}

export class dataItemDto {
  constructor(data = {}) {
    dataItem.forEach(key => (this[key] = data[key] || null));
  }
}

export class gridDto {
  constructor(data = {}) {
    dataInfo.forEach(key => (this[key] = data[key] || null));
  }
}
